"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ForecastIcon = function ForecastIcon() {
  return _react2.default.createElement(
    "svg",
    {
      className: "quiver-forecast-icon",
      viewBox: "0 0 16 16"
    },
    _react2.default.createElement("path", {
      fillRule: "nonzero",
      d: "M8.636 4.469C5.731 3.346 3.519 4.304 2 7.342V12h12S2.492 9.498 8.636 4.469z"
    })
  );
};

exports.default = ForecastIcon;


//////////////////
// WEBPACK FOOTER
// ./~/@surfline/quiver-react/dist/ForecastIcon/ForecastIcon.js
// module id = 285
// module chunks = 0